<template lang="pug">
.footprint-picker
  .indicator
    .wrapper(ref="indicator")
      img.pin(ref="pin" src="~assets/indicator-pin.jpg")
  .slides
    .swiper-container(ref="swiper")
      .swiper-wrapper(ref="swiperWrapper")
        .swiper-slide(v-for="(ex, i) in $t('exhibits')" :key="i" @click="onClick(i)" :class="selectedIdx===i? 'active': ''")
          .card
            img(:src="ex.icon")
          .name {{ex.name}}


            
</template>
<script>
import Swiper from 'swiper'
import Raf from '@/helpers/Raf'
import b from '@/assets/icons/b.png'
import c from '@/assets/icons/c.png'
import d from '@/assets/icons/d.png'
import e from '@/assets/icons/e.png'
import f from '@/assets/icons/f.png'
import g from '@/assets/icons/g.png'
import h from '@/assets/icons/h.png'
export default {
  name: 'FootprintPicker',
  components: {},
  props: {
    timeTable: {},
  },
  data() {
    return {
      selectedIdx: -1,
      lineOffset: 0,
      lineOffsetTo: 0,
      pinOffset: 0,
      pinOffsetTo: 0,
      lineEl: null,
      swiperWrapperEl: null,
      pinEl: null,
      exhibits: {
        d: d,
        b: b,
        c: c,
        e: e,
        f: f,
        g: g,
        h: h,
      },
    }
  },
  computed: {},
  methods: {
    onClick(idx) {
      this.selectedIdx = idx
      this.pinEl.style.marginLeft = window.innerWidth + 'px'
      this.pinEl.style.transform = `translate3d(${this.pxToRem(
        51 + 80 + idx * 220
      )}, 0, 0)`
    },
    pxToRem(px) {
      return `${px * 0.01}rem`
    },
    syncIndicator() {
      this.lineEl.style.transform = this.swiperWrapperEl.style.transform
      this.lineEl.style.transitionDuration = this.swiperWrapperEl.style.transitionDuration
    },
  },
  mounted() {
    //const that = this
    this.swiper = new Swiper(this.$refs.swiper, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 30,
      freeMode: true,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
    })
    this.lineEl = this.$refs.indicator
    this.swiperWrapperEl = this.$refs.swiperWrapper
    this.pinEl = this.$refs.pin

    this.lineEl.style.width = `${this.swiper.$wrapperEl[0].scrollWidth +
      window.innerWidth * 2}px`
    this.lineEl.style.left = `${-window.innerWidth}px`

    Raf.add(this.syncIndicator)
    this.onClick(0)
  },
  updated() {
    // this.swiper.update()
    // //console.log(777, this.swiper.$wrapperEl)
    // this.lineEl.style.width = `${this.swiper.$wrapperEl[0].scrollWidth +
    //   window.innerWidth * 2}px`
    // this.lineEl.style.left = `${-window.innerWidth}px`
  },
  destroy() {
    Raf.remove(this.syncIndicator)
  },
}
</script>

<style scoped lang="sass">
@import "~swiper/swiper-bundle.min.css"
@import "../../styles/common"
.footprint-picker
  position: relative
  width: 100%
  overflow: hidden
  .indicator
    width: 100%
    //margin-top: pxToRem(80)
    .wrapper
      position: relative
      height: pxToRem(49)
      width: 100%
      background-image: url("~assets/indicator-line.jpg")
      background-repeat: repeat-x
      background-size: auto 100%
      .pin
        position: absolute
        top: 0
        left: pxToRem(-81)
        transition: transform 0.5s ease
        height: 100%
        width: pxToRem(51)
  .swiper-container
    margin-top: pxToRem(30)
    overflow: visible
    position: relative
    //background: #f7a41a
    width: 100%
    //height: 100%
    .swiper-slide
      //background: #fff
      width: pxToRem(160)
      //height: pxToRem(180)
      &.active
        .card
          transform: scale(1.2)
          box-shadow: pxToRem(2) pxToRem(13) pxToRem(23) pxToRem(-10) rgba(22,139,255,0.60)
        .name
          color: $cl-blue
      .card
        width: pxToRem(160)
        height: pxToRem(160)
        //background: #3a54a2
        overflow: hidden
        border-radius: pxToRem(16)
        transform-origin: bottom
        img
          width: 100%

      .name
        margin-top: pxToRem(20)
        font-family: $ff-cn
        text-align: center
        font-size: pxToRem(26)
        line-height: pxToRem(40)
        color: black
</style>
